module.exports = __webpack_public_path__ + "img/r2@2x.03335852.png";